import {PassedInitialConfig} from 'angular-auth-oidc-client';
import {environment} from 'src/environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.authServer,
    redirectUrl: window.location.origin + window.location.pathname,
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.clientId,
    scope: environment.scope,
    responseType: environment.responseType,
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    secureRoutes: [environment.api, environment.adminApi],
    unauthorizedRoute: '/unauthorized',
    triggerAuthorizationResultEvent: true,
    logLevel: environment.showDebugInformation ? 1 : 0, // 1 = Debug, 0 = None
  }
};
